import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksSelect.module.scss';

interface Props extends React.HTMLProps<HTMLSelectElement> {
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  selected: boolean;
}

const BooksSelect = ({
  className,
  children,
  intl,
  name,
  value,
  onChange,
  selected,
}: Props & InjectedIntlProps) => {
  const classes = classNames(
    css.BooksSelect,
    { [css.isSelected]: selected },
    className,
  );

  return (
    <select className={classes} name={name} value={value} onChange={onChange}>
      <option value={''} className={css.BooksSelect__Placeholder}>
        {intl.formatMessage({ id: 'books.forms.pleaseSelect' })}
      </option>
      {children}
    </select>
  );
};

export default injectIntl(BooksSelect);
